import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-arrows',
  templateUrl: './gas-icon-arrows.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconArrowsComponent { }
